export function getItemId(configId: string | undefined, name: string, configIndex: number) {
    return `${configId || 'ControlledAccordions'}-${name}-${configIndex}`;
}
